module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/light-slider/slider2/slider2.component.scss
// module id = ./src/app/features/light-slider/slider2/slider2.component.scss
// module chunks = main